import { createContext} from 'react';
import {Theme } from '@fluentui/react-components';

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export interface ThemeContextType {
    theme: Theme;
    toggleTheme: () => void;
  }
